export default function () {
  return {
    properties: [],
    property: null,
    transactions: null,
  };
}
